import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateMaintenanceState() {
    return (
        <div data-cy="history-updateMaintenanceState">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateMaintenanceState" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faExclamationCircle} size="lg" />
            </Whisper>
        </div>
    );
}
